import apiClient from '../config/api';

const kaizenActionService = {
  /**
   * Get all Kaizen actions for a specific idea
   * @param {number} ideaId - Kaizen idea ID
   * @returns {Promise} Array of Kaizen actions
   */
  getKaizenActionsByIdea: async (ideaId) => {
    const response = await apiClient.get(`/kaizenaction/idea/${ideaId}`);
    return response.data;
  },

  /**
   * Get all Kaizen actions assigned to a user
   * @param {number} assigneeId - User ID
   * @returns {Promise} Array of Kaizen actions
   */
  getKaizenActionsByAssignee: async (assigneeId) => {
    const response = await apiClient.get(`/kaizenaction/assignee/${assigneeId}`);
    return response.data;
  },

  /**
   * Get Kaizen action by ID
   * @param {number} actionId - Kaizen action ID
   * @returns {Promise} Kaizen action details
   */
  getKaizenActionById: async (actionId) => {
    const response = await apiClient.get(`/kaizenaction/${actionId}`);
    return response.data;
  },

  /**
   * Create a new Kaizen action
   * @param {object} actionData - Kaizen action data
   * @returns {Promise} Created Kaizen action
   */
  createKaizenAction: async (actionData) => {
    const response = await apiClient.post('/kaizenaction', actionData);
    return response.data;
  },

  /**
   * Update Kaizen action
   * @param {number} actionId - Kaizen action ID
   * @param {object} actionData - Updated Kaizen action data
   * @returns {Promise} Updated Kaizen action
   */
  updateKaizenAction: async (actionId, actionData) => {
    const response = await apiClient.post(`/kaizenaction/update/${actionId}`, actionData);
    return response.data;
  },

  /**
   * Mark Kaizen action as completed
   * @param {number} actionId - Kaizen action ID
   * @returns {Promise} Completed Kaizen action
   */
  completeKaizenAction: async (actionId) => {
    const response = await apiClient.post(`/kaizenaction/${actionId}/complete`);
    return response.data;
  },

  /**
   * Delete Kaizen action
   * @param {number} actionId - Kaizen action ID
   * @returns {Promise} Deletion result
   */
  deleteKaizenAction: async (actionId) => {
    const response = await apiClient.post(`/kaizenaction/delete/${actionId}`);
    return response.data;
  },
};

export default kaizenActionService;

